import { render, staticRenderFns } from "./GastosProveedor.vue?vue&type=template&id=7b71a8cd&scoped=true&"
import script from "./GastosProveedor.vue?vue&type=script&lang=js&"
export * from "./GastosProveedor.vue?vue&type=script&lang=js&"
import style0 from "./GastosProveedor.vue?vue&type=style&index=0&id=7b71a8cd&prod&lang=scss&"
import style1 from "./GastosProveedor.vue?vue&type=style&index=1&id=7b71a8cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71a8cd",
  null
  
)

export default component.exports